import { APICore } from "./apiCore";

const api = new APICore();

/**
 * Dados fiscais do plano, o tomador da nota de convênio. CNPJ e CEP só com
 * dígitos; CNPJ válido e razão social são exigidos para emitir a nota.
 */
export interface IDadosFaturamentoPlano {
  cnpj?: string | null;
  razao_social?: string | null;
  email?: string | null;
  cep?: string | null;
  logradouro?: string | null;
  endereco_numero?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  uf?: string | null;
}

const criarPlanoSaude = (
  params: { nome: string; unidade_id: number } & IDadosFaturamentoPlano
) => {
  return api.create("/planosaude", params);
};

const atualizarPlanoSaude = (
  id: string,
  params: { nome?: string; unidade_id?: number } & IDadosFaturamentoPlano
) => {
  return api.update(`/planosaude/${id}`, params);
};

const deletarPlanoSaude = (id: string) => {
  return api.delete(`/planosaude/${id}`);
};

const getPlanoSaudes = (queryString?: string) => {
  return api.get(`/planosaude${queryString ? queryString : ""}`);
};

const getPlanoSaude = (id: string) => {
  return api.get(`/planosaude/${id}`);
};

export {
  criarPlanoSaude,
  atualizarPlanoSaude,
  deletarPlanoSaude,
  getPlanoSaude,
  getPlanoSaudes,
};
